import React, { useState } from 'react';
import { Package, Trash2, MapPin } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';
import Button from '../ui/Button';
import TransferToWasteForm from './TransferToWasteForm';

interface ManufacturedProductLocationManagerProps {
  product: any;
  onTransferComplete?: () => void;
}

const ManufacturedProductLocationManager: React.FC<ManufacturedProductLocationManagerProps> = ({
  product,
  onTransferComplete
}) => {
  const [showWasteTransferForm, setShowWasteTransferForm] = useState(false);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex justify-between items-center">
            <CardTitle>Location & Stock</CardTitle>
            <Button
              variant="danger"
              onClick={() => setShowWasteTransferForm(true)}
            >
              <Trash2 className="h-4 w-4 mr-2" />
              Transfer to Waste
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg bg-gray-50">
              <div className="flex items-center">
                <div className="p-2 bg-white rounded-full mr-3">
                  <MapPin className="h-5 w-5 text-gray-600" />
                </div>
                <div>
                  <h4 className="font-medium text-gray-900">
                    {product.location || 'No location set'}
                  </h4>
                  <p className="text-sm text-gray-500">Primary location</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="flex items-center justify-center mb-2">
                  <Package className="h-5 w-5 text-blue-600 mr-2" />
                </div>
                <div className="text-2xl font-bold text-blue-900">{product.stock_quantity || 0}</div>
                <div className="text-sm text-blue-600">Total Stock</div>
              </div>
              <div className="text-center p-4 bg-amber-50 rounded-lg">
                <div className="text-2xl font-bold text-amber-900">{product.min_stock_level || 0}</div>
                <div className="text-sm text-amber-600">Minimum Level</div>
              </div>
            </div>

            {product.stock_quantity <= product.min_stock_level && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-sm text-red-800">
                  Stock is at or below minimum level. Consider producing more units.
                </p>
              </div>
            )}
          </div>
        </CardContent>
      </Card>

      {showWasteTransferForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 overflow-y-auto">
          <div className="min-h-screen flex items-center justify-center p-4 py-8">
            <TransferToWasteForm
              sourceType="manufactured_products"
              sourceItem={product}
              productLocations={[]}
              onTransferComplete={() => {
                setShowWasteTransferForm(false);
                onTransferComplete?.();
              }}
              onCancel={() => setShowWasteTransferForm(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ManufacturedProductLocationManager;
